module.exports = __webpack_public_path__ + "img/mm-customercenter.ec8e1f13.png";